import { extendAddDays } from "@js/nwcc-extensions.js";

export const networkDefaultReports = {
    SNTL: "YEARLY STATUS REPORT",
    SNOW: "SNOW HISTORY REPORT",
    SCAN: "SOIL AND CLIMATE REPORT",
    SNTLT: "SNOW DEPTH REPORT",
};

export function showLoadingBar(show = true) {
    const loading = document.getElementById("loading-bar");
    if (show) {
        loading?.classList.remove("fsa-hide");
    } else {
        loading?.classList.add("fsa-hide");
    }
}

export async function writeClipboardText(text) {
    return await navigator.permissions
        .query({ name: "clipboard-write" })
        .then(async (result) => {
            if (result.state === "granted") {
                await navigator.clipboard.writeText(text);
                return true;
            }
            return false;
        })
        .catch((error) => {
            console.error(error.message);
            return false;
        });
}

export function pickerToApiDateFormat(dateStr) {
    const dateStrArr = dateStr.split("/");
    const year = `${dateStrArr[2]}`;
    const month = `${dateStrArr[0].length > 1 ? dateStrArr[0] : "0" + dateStrArr[0]}`;
    const day = `${dateStrArr[1].length > 1 ? dateStrArr[1] : "0" + dateStrArr[1]}`;
    return `${year}-${month}-${day}`;
}

export function dateToPickerDateFormat(date) {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`;
    const day = date.getDate();
    return `${month}/${day}/${year}`;
}

export function getDefaultDateConvention(duration, conventionType) {
    const today = new Date();
    const thisMorning = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0);
    const thisEvening = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59);
    extendAddDays();
    const defaultDateConventions = {
        hourly: [thisMorning.addDays(-8), thisEvening],
        daily: [thisMorning.addDays(-41), thisEvening],
        semimonthly: [thisMorning.addDays(-367), thisEvening],
        monthly: [thisMorning.addDays(-367), thisEvening],
        water_year: [thisMorning.addDays(-3654), thisEvening],
        calendar_year: [thisMorning.addDays(-3654), thisEvening],
    };
    const conventions = defaultDateConventions[duration?.toLowerCase()] || defaultDateConventions.monthly;
    return conventionType.toLowerCase() === "begin"
        ? dateToPickerDateFormat(conventions[0])
        : dateToPickerDateFormat(conventions[1]);
}

export function convertDateToRelative(dateStr) {
    const date = new Date(`${dateStr} 00:00`);
    const today = new Date();
    const diffDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0);
    const timeDifference = diffDate.getTime() - date.getTime();
    const daysDifference = Math.round(timeDifference / (1000 * 60 * 60 * 24));
    return `${-1 * daysDifference}`;
}
